import React from 'react'
import { Tab } from 'semantic-ui-react'

import Statistik from '../dashboard/Statistik'
import KalkulasiSTS from './views/admin/_sts/KalkulasiSTS';
import KalkulasiBPFilter from './views/admin/_bp/KalkulasiBPFilter';
import { isAdmin, isVerificator } from '../../_utils/localstorage';
import AnggaranRealisasiSKPD from './views/admin/_report/AnggaranRealisasiSKPD';
import AnggaranRealisasiOPD from './views/admin/_report/AnggaranRealisasiOPD';

if(isAdmin() || isVerificator()){
   var panes = [
      { 
      menuItem: 'Statistik', 
      render: () => <Tab.Pane attached={false}><Statistik /></Tab.Pane> 
      },
      { 
         menuItem: 'Kalkulasi STS', 
         render: () => <Tab.Pane attached={false}><KalkulasiSTS /></Tab.Pane> 
      },
      { 
         menuItem: 'Kalkulasi BP', 
         render: () => <Tab.Pane attached={false}><KalkulasiBPFilter /></Tab.Pane> 
      },
      { 
         menuItem: 'Target dan Realisasi SKPD', 
         render: () => <Tab.Pane attached={false}><AnggaranRealisasiSKPD /></Tab.Pane> 
      },
      { 
         menuItem: 'Target dan Realisasi OPD', 
         render: () => <Tab.Pane attached={false}><AnggaranRealisasiOPD /></Tab.Pane> 
      },
   ]
}else{
   panes = [
      { 
      menuItem: 'Statistik', 
      render: () => <Tab.Pane attached={false}><Statistik /></Tab.Pane> 
      },
      { 
         menuItem: 'Kalkulasi STS', 
         render: () => <Tab.Pane attached={false}><KalkulasiSTS /></Tab.Pane> 
      },
      { 
         menuItem: 'Kalkulasi BP', 
         render: () => <Tab.Pane attached={false}><KalkulasiBPFilter /></Tab.Pane> 
      }
   ]
}
const Dashboard = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Content/Dashboard.js